export default __webpack_public_path__ + "static/media/friendsAdda.574d3a0c.png";